// ============================================================
// Đổi giá trị ngày/giờ từ máy chủ về đúng dạng mà ô nhập hiểu
// ============================================================
//
// ⚠️ CÁI BẪY MÚI GIỜ — ĐỌC KỸ TRƯỚC KHI SỬA ĐOẠN NÀY
//
// Cột kiểu `date` trong PostgreSQL, khi đi qua thư viện `pg` rồi gửi về
// trình duyệt, biến thành chuỗi kiểu "2026-09-04T17:00:00.000Z".
// Đó VẪN LÀ ngày 05/09 theo giờ Việt Nam — chỉ là được ghi theo giờ quốc tế
// (Việt Nam đi trước 7 tiếng, nên nửa đêm ở ta là 17 giờ chiều hôm trước bên đó).
//
// Vì vậy TUYỆT ĐỐI KHÔNG được dùng cách này:
//
//        new Date(giaTri).toISOString().slice(0, 10)      ❌ SAI
//
// Nó cho ra "2026-09-04" — LÙI MẤT MỘT NGÀY. Lỗi này rất khó phát hiện vì
// nó chỉ sai với một số ngày, và chỉ sai đúng 1 ngày nên nhìn thoáng qua
// tưởng đúng.
//
// Cách đúng là đọc năm/tháng/ngày theo GIỜ ĐỊA PHƯƠNG, như bên dưới.
// ============================================================

/**
 * Đổi về dạng "YYYY-MM-DD" cho ô <input type="date">.
 * Trả về chuỗi rỗng nếu không có giá trị hoặc giá trị không hợp lệ.
 */
export const veDangNgay = (giaTri) => {
  if (!giaTri) return "";

  // Đã đúng dạng rồi thì giữ nguyên (ví dụ người dùng vừa gõ vào ô)
  if (typeof giaTri === "string" && /^\d{4}-\d{2}-\d{2}$/.test(giaTri)) {
    return giaTri;
  }

  const d = new Date(giaTri);
  if (isNaN(d.getTime())) return "";

  const nam = d.getFullYear();
  const thang = String(d.getMonth() + 1).padStart(2, "0");
  const ngay = String(d.getDate()).padStart(2, "0");
  return `${nam}-${thang}-${ngay}`;
};

/**
 * Đổi về dạng "HH:MM" cho ô <input type="time">.
 * Máy chủ trả về "07:59:00", ô nhập muốn "07:59".
 */
export const veDangGio = (giaTri) => {
  if (!giaTri) return "";
  const khop = String(giaTri).match(/^(\d{1,2}):(\d{2})/);
  if (!khop) return "";
  return `${khop[1].padStart(2, "0")}:${khop[2]}`;
};
